import { FC, Dispatch, SetStateAction } from 'react'
import {
  FormContainer,
  FormItemContainer,
  AreasOfPracticeCheckboxContainer,
  AreasOfPracticeCheckboxItem,
  SubAreasOfPracticeContainer
} from 'src/components/application/defaultComponents'
import StandardCheckbox from 'src/components/basic/StandardCheckbox'
import { LeftBar } from 'src/components/basic/LeftBar'
import { areasOfPractice, subareasOfPractice } from 'src/constants/application'
import StandardInput from 'src/components/basic/StandardInput'
import StandardRadio from 'src/components/basic/StandardRadio'
import { FormInputErrorMessage } from 'src/components/application/formComponents/styles'

interface Props {
  handleAreaSelect: (area: string) => void;
  isAreaSelected: (area: string) => boolean;
  otherInput: string;
  setOtherInput: Dispatch<SetStateAction<string>>;
  handleSubAreaSelect: (area: string, subArea: string) => void;
  isSubAreaSelected: (subArea: string) => boolean;
  utilizePatentAgents: string;
  setUtilizePatentAgents: Dispatch<SetStateAction<string>>;
  howManyAgents: string | number;
  setHowManyAgents: Dispatch<SetStateAction<string | number>>;
  isSubAreaInvalid?: boolean;
}

const PracticeForm: FC<Props> = ({
  handleAreaSelect,
  isAreaSelected,
  otherInput,
  setOtherInput,
  handleSubAreaSelect,
  isSubAreaSelected,
  utilizePatentAgents,
  setUtilizePatentAgents,
  howManyAgents,
  setHowManyAgents,
  isSubAreaInvalid
}) => {
  return (
    <FormContainer maxWidth='624px'>
      <FormItemContainer maxWidth='560px'>
        <AreasOfPracticeCheckboxContainer>
          {areasOfPractice.map((area, index) => (
            <AreasOfPracticeCheckboxItem key={index}>
              <StandardCheckbox
                variation="medium"
                label={area}
                withBg
                onChange={() => handleAreaSelect(area)}
                checked={isAreaSelected(area)}
              />
              {(area === 'Other' && isAreaSelected(area)) ? (
                <SubAreasOfPracticeContainer>
                  <LeftBar />
                  <div className="subareas-container">
                    <StandardInput
                      label='Please list other area(s) of practice below.'
                      onChange={e => setOtherInput(e.target.value)}
                      value={otherInput}
                    />
                  </div>
                </SubAreasOfPracticeContainer>
              ) : null}
              {(Object.keys(subareasOfPractice).includes(area) && isAreaSelected(area)) ? (
                <SubAreasOfPracticeContainer>
                  <LeftBar />
                  <div className='subareas-container'>
                    <span className='subarea-title'>Please select the specific types of {area.toLowerCase()} law you practice.</span>
                    {isSubAreaInvalid && !subareasOfPractice[area].some(subArea => isSubAreaSelected(subArea)) ? (
                      <FormInputErrorMessage id="practiceform__error_message">
                        You must select at least 1 specific type
                      </FormInputErrorMessage>
                    ) : null}
                    {subareasOfPractice[area].map((subArea, subIndex) => (
                      <StandardCheckbox
                        key={subIndex}
                        variation="small"
                        label={subArea}
                        withBg
                        onChange={() => handleSubAreaSelect(area, subArea)}
                        checked={isSubAreaSelected(subArea)}
                      />
                    ))}
                    {area === 'Intellectual Property' ? (
                      <>
                        <span className='subarea-title'>Does the Applicant utilize patent agents?</span>
                        {isSubAreaInvalid && !utilizePatentAgents && (
                          <FormInputErrorMessage id="practiceform__error_message">
                            This is a required field
                          </FormInputErrorMessage>
                        )}
                        <div className='radio-options'>
                          <StandardRadio
                            label="Yes"
                            checked={utilizePatentAgents === 'Yes'}
                            onChange={() => setUtilizePatentAgents('Yes')}
                          />
                          <StandardRadio
                            label="No"
                            checked={utilizePatentAgents === 'No'}
                            onChange={() => {
                              setUtilizePatentAgents('No')
                              setHowManyAgents('')
                            }}
                          />
                        </div>
                        {utilizePatentAgents === 'Yes' ? (
                          <div style={{ width: '200px' }}>
                            <StandardInput
                              label='How many agents?'
                              onChange={e => setHowManyAgents(e.target.value)}
                              value={howManyAgents}
                              type="number"
                            />
                            {isSubAreaInvalid && howManyAgents === '' && (
                              <FormInputErrorMessage id="practiceform__error_message">
                                This is a required field
                              </FormInputErrorMessage>
                            )}
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </SubAreasOfPracticeContainer>
              ) : null}
            </AreasOfPracticeCheckboxItem>
          ))}
        </AreasOfPracticeCheckboxContainer>
      </FormItemContainer>
    </FormContainer>
  )
}

export default PracticeForm